import React, { useEffect, useState } from 'react';
import { Oval } from 'react-loader-spinner';
import api from '../services/api';
import LazyImage from '../components/LazyImage';
import { Page, Header, Section, ImageWrap, Content } from './AboutStyles';

const About = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    api.about.get().then(setData).catch(err => setError(err.message)).finally(() => setLoading(false));
  }, []);

  if (loading) return (
    <div style={{ minHeight: '60vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <Oval height={48} width={48} color="#2E8B57" secondaryColor="#CDEAD7" />
    </div>
  );
  if (error) return <div style={{ padding: 20 }}>Error: {error}</div>;
  if (!data) return null;

  const { bio, mission, vision, goals, images, additionalSections } = data;

  const goalLines = (goals || '').split('\n').map(line => line.trim()).filter(Boolean);

  return (
    <Page>
      <Header>
        <h1>About Us</h1>
        <p>Learn more about the Food Authority Liberia (FAL).</p>
      </Header>

      <Section>
        <Content>
          <h3>Bio</h3>
          <p>{bio || '—'}</p>
        </Content>
        {images?.bioImage ? (
          <ImageWrap><LazyImage src={images.bioImage} alt="Bio" /></ImageWrap>
        ) : <div />}
      </Section>

      <Section>
        <Content>
          <h3>Mission</h3>
          <p>{mission || '—'}</p>
        </Content>
        {images?.missionImage ? (
          <ImageWrap><LazyImage src={images.missionImage} alt="Mission" /></ImageWrap>
        ) : <div />}
      </Section>

      <Section>
        <Content>
          <h3>Vision</h3>
          <p>{vision || '—'}</p>
        </Content>
        {images?.visionImage ? (
          <ImageWrap><LazyImage src={images.visionImage} alt="Vision" /></ImageWrap>
        ) : <div />}
      </Section>

      <Section>
        <Content>
          <h3>Goals</h3>
          {goalLines.length ? (
            <ul>
              {goalLines.map((line, idx) => (
                <li key={idx}>{line}</li>
              ))}
            </ul>
          ) : (
            <p>—</p>
          )}
        </Content>
        {images?.goalsImage ? (
          <ImageWrap><LazyImage src={images.goalsImage} alt="Goals" /></ImageWrap>
        ) : <div />}
      </Section>

      {(additionalSections || []).map((sec, idx) => (
        <Section key={idx}>
          <Content>
            <h3>{sec.title || 'Section'}</h3>
            {sec.type === 'list'
              ? (
                <ul>
                  {(sec.content || '').split('\n').map(line => line.trim()).filter(Boolean).map((line, liIdx) => (
                    <li key={liIdx}>{line}</li>
                  ))}
                </ul>
              ) : (
                <p>{sec.content || '—'}</p>
              )}
          </Content>
          {sec.image ? (
            <ImageWrap><LazyImage src={sec.image} alt={sec.title || 'Section'} /></ImageWrap>
          ) : <div />}
        </Section>
      ))}
    </Page>
  );
};

export default About;
